module.exports = __webpack_public_path__ + "img/dishesconfirm1.d17e84c0.png";